
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.37 0H6.21A6.218 6.218 0 000 6.21v40.58A6.218 6.218 0 006.21 53h40.58A6.218 6.218 0 0053 46.79V7.63L45.37 0zM12.421 4.14H36.23v12.215H12.422V4.141zm28.156 44.72H12.422V32.503h28.156v16.355zm8.281-2.07c0 1.14-.928 2.07-2.07 2.07h-2.07V28.362H8.28V48.86h-2.07a2.073 2.073 0 01-2.07-2.07V6.211c0-1.142.928-2.07 2.07-2.07h2.07v16.355h32.09V4.141h3.283l5.205 5.205v37.443z"}}),_c('path',{attrs:{"d":"M32.504 6.107h-4.14v8.178h4.14V6.107z"}})])
          )
        }
      }
    